import { render, staticRenderFns } from "./project_details1.vue?vue&type=template&id=40c015c5&scoped=true&"
import script from "./project_details1.vue?vue&type=script&lang=js&"
export * from "./project_details1.vue?vue&type=script&lang=js&"
import style0 from "./project_details1.vue?vue&type=style&index=0&id=40c015c5&lang=scss&scoped=true&"
import style1 from "./project_details1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c015c5",
  null
  
)

export default component.exports